import { connect } from "react-redux";
import History from "../components/History";
import { resendTask, completeTask, getHistory, getPerson, PERSON, resetState, TASK_ACTION, transferTask } from "../../actions-index";
import formDefinitions from "../../Forms/paths";
import { ACTION_STATUS } from "../../util/constants";

const mapStateToProps = (state = {}, ownProps = {}) => {
  const { formId, osuid } = ownProps
  const user = (state?.authentication?.user ?? {});
  const { isEnrollmentAdmin = false, isGraduationAdmin = false, osuid: userId } = user;
  const emplid = (osuid ?? userId);
  const isAdmin = ([isEnrollmentAdmin, isGraduationAdmin].includes(true));
  
  const { columns, history, status } = state?.form?.history?.[formId] ?? {}

  const formTypeFriendly = ownProps?.match?.params?.formType;
  const formType = formDefinitions[formTypeFriendly]?.formType;

  const { status: personStatus = "", data: person = {} } = state.person;

  return {
    columns,
    emplid,
    formType,
    history, 
    isAdmin,
    person,
    personStatus,
    status,
    error: (status === ACTION_STATUS.ERROR) ? "Could not load history for this form." : "",
    taskActionMessage: (state?.taskAction?.message ?? null),
    taskActionStatus: (state?.taskAction?.status ?? "")
  };
};

const mapDispatchToProps = (dispatch) => ({
  completeTask: (values) => dispatch(completeTask(values)),
  getHistory: ({ emplid, formType, id }) => dispatch(getHistory({ emplid, formType, id })),
  getPerson: (emplid) => dispatch(getPerson(emplid)),
  resetTaskAction: () => dispatch(resetState(TASK_ACTION, {})),
  resendTask: (values) => dispatch(resendTask(values)),
  resetPerson: () => dispatch(resetState(PERSON, {})),
  transferTask: (values) => dispatch(transferTask(values))
});

export default connect(mapStateToProps, mapDispatchToProps)(History);
